import { throttle } from '@/utils/utils'

let throttleHandle = (el: any, binding: any) => {
    if (typeof binding.value.handle !== 'function') return
    const handle = throttle(binding.value.handle, binding.value.delay || 3000, { trailing: false })
    binding.value.handle.stop = handle.cancel

    return handle
}

// 防止多次重复点击
export default {
    inserted(el: any, binding: any) {
        el.addEventListener('click', throttleHandle(el, binding), false)
    },
    unbind(el: any) {
        el.removeEventListener('click', throttleHandle, false)
    }
}
